import { Component } from '@angular/core'
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-ext-auth-page-success',
    templateUrl: './ext-auth-page-success.component.html',
    styleUrl: './ext-auth-page-success.component.scss',
    standalone: true,
    imports: [RouterLink],
})
export class ExtAuthPageSuccessComponent {}
